import { render, staticRenderFns } from "./SCopyBtn.vue?vue&type=template&id=554a62de"
import script from "./SCopyBtn.vue?vue&type=script&lang=js"
export * from "./SCopyBtn.vue?vue&type=script&lang=js"
import style0 from "./SCopyBtn.vue?vue&type=style&index=0&id=554a62de&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports